import { lazy } from "react";

export const EmpDashboardLazy = lazy(() =>
  import("../components/organisms/Employee/EmployeeDashboard")
);

export const UserManagementLazy = lazy(() => import("../pages/UserMangement"));

export const NeValidationLazy = lazy(() => import("../pages/NeValidation"));

export const AddUserComponentLazy = lazy(() => import("../pages/AddUser"));

export const EditUserComponentLazy = lazy(() => import("../pages/EditUser"));

export const ApprovalScreenLazy = lazy(() => import("../pages/ApprovalScreen"));

export const TicketTrackerScreenLazy = lazy(() =>
  import("../pages/TicketTrackerScreen")
);

export const LicenseVerificationLazy = lazy(() =>
  import("../pages/LicenseVerification")
);

export const NeApprovalLazy = lazy(() => import("../pages/NeApproval"));

export const BulkUploadLazy = lazy(() => import("../pages/BulkUpload"));

export const StatusScreenLazy = lazy(() => import("../pages/StatusScreen"));

export const PartnerDashboardLazy = lazy(() =>
  import("../components/organisms/Partner/PartnerDashboard")
);

export const PartnerFeedbackLazy = lazy(() =>
  import("../pages/PartnerFeedback")
);

export const AddFeedbackLazy = lazy(() => import("../pages/AddFeedback"));

export const ProspectEvaluationLazy = lazy(() =>
  import("../pages/ProspectEvaluation")
);

export const EvaluatePartnerProspectLazy = lazy(() =>
  import("../pages/ProspectEvaluation/EvaluatePartnerProspect")
);

export const AddProspectLazy = lazy(() =>
  import("../pages/ProspectEvaluation/AddProspect")
);

export const ViewLcoDashboard = lazy(() => import("../pages/ViewLcoDashboard"));
export const AddLCOPartnership = lazy(() =>
  import("../pages/AddLCOPartnership")
);

export const AddLicense = lazy(() => import("../pages/AddLicense"));
export const PolygonCreation = lazy(() => import("../pages/PolygonCreation"));
export const PartnerDashboardDetail = lazy(() =>
  import("../pages/PartnerDashboardDetail")
);

export const PartnerTicketTracker = lazy(() =>
  import("../pages/PartnerContactUs")
);

export const CommissionSummary = lazy(() =>
  import("../pages/CommissionSummary")
);

export const Cart = lazy(() => import("../pages/Cart"));

export const ManageTeam = lazy(() => import("../pages/ManageTeam"));
export const IronMan = lazy(() => import("../pages/IronManCalling"));
export const ManageOrders = lazy(() => import("../pages/ManageOrders"));
export const OrderDetail = lazy(() =>
  import("../pages/ManageOrders/OrderDetail")
);
export const OrderUpdate = lazy(() => import("../pages/OrderUpdate/index.jsx"));
export const MasterConfig = lazy(() => import("../pages/MasterConfig"));
export const AirtelAmbassador = lazy(() => import("../pages/AirtelAmbassador"));

export const ChangePassword = lazy(() => import("../pages/ChangePassword"));
export const MyProfileComponent = lazy(() =>
  import("../components/organisms/MyProfileComponent")
);
export const MarketCart = lazy(() => import("../pages/MarketCart"));
export const AirCoin = lazy(() => import("../pages/AirCoin"));
export const MyBaseComponent = lazy(() =>
  import("../components/organisms/MyBaseComponent")
);
export const RevenueComponent = lazy(() =>
  import("../components/organisms/RevenueComponent")
);
export const NetworkView = lazy(() => import("../pages/NetworkView"));
export const OrderInstallments = lazy(() =>
  import("../pages/ManageOrders/OrderInstallments")
);
export const ManageInvoices = lazy(() => import("../pages/ManageInvoices"));
export const CustomerDownTime = lazy(() =>
  import("../pages/CustomerDownTime/index.jsx")
);
export const CDTDetails = lazy(() =>
  import("../pages/CustomerDownTime/CDTDetails.jsx")
);
export const SafetyCompliance = lazy(() => import("../pages/SafetyCompliance"));
export const InsuredUsers = lazy(() => import("../pages/InsuredUsers"));

export const FnfInitiate = lazy(() => import("../pages/FnfInitiate"));
// marketplace loadables components
export const ScmLogin = lazy(() => import("../pages/Login/login.jsx"));
export const ScmDashboard = lazy(() => import("../pages/ScmDashboard"));
export const ScmProductCatalog = lazy(() =>
  import("../pages/ScmProductCatalog")
);
export const ScmCart = lazy(() => import("../pages/ScmCart"));
export const ProductPage = lazy(() => import("../pages/Product/index.jsx"));
export const ScmMyOrders = lazy(() => import("../pages/ScmOrders/index.jsx"));
export const ScmBulkUpload = lazy(() =>
  import("../pages/ScmBulkUpload/index.jsx")
);
export const OmniWidget = lazy(() => import("../pages/OmniWidget"));
export const ScmManageCatalog = lazy(() => import("../pages/ScmManageCatalog/index.jsx"));
